import { FC } from 'react'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { Error404 } from 'Error404'
import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { ConnectedAppsPage } from './pages/ConnectedAppsPage'

export const ConnectedApps: FC = () => {
  return (
    <AuthenticatedRoute path={'/connected-apps'} redirectPath={'/connected-apps'} exact>
      <LaunchDarklyDependentContent flagName="useNewConnectedApps" fallbackContent={<Error404 />}>
        <ConnectedAppsPage/>
      </LaunchDarklyDependentContent>
    </AuthenticatedRoute>
  )
}
